export default __webpack_public_path__ + "static/media/Profile.608dff4b.png";